import {MyTop10GamesState} from '../../reducers/fortnite-game/myTop10Games.reducer';

export const getMyTop10GamesState = (state): MyTop10GamesState => {
    return state.get('myTop10Games').toJS();
};
